<template>
    <b-button
        variant="primary"
        @click.stop="verificarSaldoNatureza()"
        :disabled="comprometimentosSelecionados.length == 0"
    >
        <span
            ><i class="fa fa-check-circle-o mr-2"></i> Comprometer
            selecionados</span
        >
    </b-button>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            saldoNaturezaOk: true
        }
    },

    methods: {
        verificarSaldoNatureza() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idContrato: this.contrato.idContrato,
                comprometimentos: this.comprometimentosSelecionados
            }
            ComprometimentosServicos.verificarSaldoNatureza(
                comprometimentosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.saldoNaturezaOk = response.data
                        this.confirmarComprometerSelecionados()
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarComprometerSelecionados() {
            let mensagem =
                'Confirma a realização dos comprometimentos selecionados no RM?'
            if (!this.saldoNaturezaOk) {
                mensagem = `Confirma a realização dos comprometimentos selecionados no RM?
                            <br/><br/>
                            <div class="alert alert-warning" role="alert">
                                <i class="fa fa-exclamation-triangle fa-lg"></i>
                                <strong>O saldo da natureza de despesa do contrato é menor que o valor total dos comprometimentos selecionados</strong>                               
                            </div>`
            }
            this.$swal({
                title: 'Comprometimento',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.comprometerSelecionados()
                }
            })
        },

        comprometerSelecionados() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idContrato: this.contrato.idContrato,
                comprometimentos: this.comprometimentosSelecionados
            }
            ComprometimentosServicos.comprometerSelecionados(
                comprometimentosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Comprometimentos realizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarComprometimentos')
                    } else {
                        this.$emit('atualizarComprometimentos')
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
